import { Reducer } from "redux";
import { Action, ActionType } from "../../../actions";
import { FormData } from "../../../state/SearchManager/FormData";

const updateFormData: Reducer<FormData> = (state: FormData = new FormData(), action: Action<ActionType, FormData>) => {
  switch (action.type) {
    case ActionType.SEARCH_MANAGER_DIAGNOSTICS_EXCEPTIONS_FORM_UPDATED:
      return { ...state, ...action.data };
    case ActionType.SEARCH_MANAGER_DIAGNOSTICS_EXCEPTIONS_FORM_RESET:
      return new FormData();
    default:
      return state;
  }
};

export default updateFormData;